<template>
    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane label="EDOX" name="first"><Edox /></el-tab-pane>
            <el-tab-pane label="Allnet" name="second"><Allnet /></el-tab-pane>
            <el-tab-pane label="VEDITEC" name="third"><Veditec /></el-tab-pane>
            <el-tab-pane label="IP CONNECT" name="fourth"><Terra /></el-tab-pane>
            <el-tab-pane label="TERRA" name="five"><Ipconnect /></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Edox from "../edox/Index"
import Veditec from "../veditec/Index"
import Terra from "../terra/Index"
import Ipconnect from "../ipconnect/Index"
import Allnet from "../allnet/Index"
export default {
  components:{
      Edox,
      Veditec,
      Terra,
      Ipconnect,
      Allnet,
  },
  created () {
  },
  watch: {
  },
  data () {
    return {
        activeName: 'first'
    }
  },
  methods: {
  },

}
</script>

<style>

</style>